import {EVENT_CATEGORY, EVENT_ACTIONS} from './edapEventsConstantsLegacy';
import {triggerEdapEventLegacy, getLabel} from './edapHelpersLegacy';

/**
 * Triggers EDAP event when a card shows up in the view
 * @param context {@link CarouselContainer.contextType}
 * @param {object} labelData - Object used by {@link getLabel} to generate 'eventlabel' {
 *     @property {string} rrm - clientRequestId AKA X-HomeAway-RequestMarker header
 *     @property {number} position - card position in carousel (basically its index)
 *     @property {string} lid - hit.listingId, for example, 121.302.120
 *     @property {string} card_title - hit.headline
 *     @property {string} card_text - hit.accommodations
 *     @property {string} im_url - hit.imageUrl
 * }
 */

export function propertyCardViewEvent(context, labelData = {}, actionLocation) {
    triggerEdapEventLegacy(context, {
        fields: {
            ...EVENT_CATEGORY,
            ...EVENT_ACTIONS.CARD_VIEW,
            ...getLabel(labelData),
            actionlocation: actionLocation,
        },
    });
}

/**
 * Triggers EDAP event when a user clicks on a card
 * @param context {@link CarouselContainer.contextType}
 * @param {object} labelData - Object used by {@link getLabel} to generate 'eventlabel' {
 *     @property {string} rrm - clientRequestId AKA X-HomeAway-RequestMarker header
 *     @property {number} position - card position in carousel (basically its index)
 *     @property {string} lid - hit.listingId, for example, 121.302.120
 *     @property {string} link - hit.propertyHref
 * }
 */

export function propertyCardClickEvent(
    context,
    labelData = {},
    actionLocation
) {
    triggerEdapEventLegacy(context, {
        fields: {
            ...EVENT_CATEGORY,
            ...EVENT_ACTIONS.CLICK,
            ...getLabel(labelData),
            actionlocation: actionLocation,
        },
    });
}

export function propertyTileClickEvent(
    context,
    labelData = {},
    actionLocation
) {
    triggerEdapEventLegacy(context, {
        event: 'property.tile.click',
        fields: {
            ...labelData,
            actionlocation: actionLocation,
        },
    });
}

export function destinationCardClickEvent(
    context,
    labelData = {},
    actionLocation
) {
    triggerEdapEventLegacy(context, {
        event: 'destination.link.click',
        fields: {
            ...labelData,
            actionLocation,
        },
    });
}

/**
 * Triggers EDAP event when carousel shows up in the view
 * @param context {@link CarouselContainer.contextType}
 * @param {object} labelData - Object used by {@link getLabel} to generate 'eventlabel' {
 *     @property {string} rrm - clientRequestId AKA X-HomeAway-RequestMarker header
 *     @property {string} carousel_title - title of the carousel returned from graphql-traveler-recommendation partial
 * }
 */

export function pageModuleViewEvent(context, actionLocation) {
    triggerEdapEventLegacy(context, {
        event: 'page.module.view',
        fields: {
            actionlocation: actionLocation,
        },
    });
}

export function carouselViewEvent(context, labelData = {}, actionLocation) {
    triggerEdapEventLegacy(context, {
        fields: {
            ...EVENT_CATEGORY,
            ...EVENT_ACTIONS.CAROUSEL_VIEW,
            ...getLabel(labelData),
            actionlocation: actionLocation,
        },
    });
}

/**
 * Triggers EDAP event when a card shows up in the view
 * @param context {@link CarouselContainer.contextType}
 * @param {object} labelData - Object used by {@link getLabel} to generate 'eventlabel' {
 *     @property {string} rrm - clientRequestId AKA X-HomeAway-RequestMarker header
 *     @property {number} position - card position in carousel (basically its index)
 *     @property {string} lid - hit.listingId, for example, 121.302.120
 *     @property {string} card_title - hit.headline
 *     @property {string} card_text - hit.accommodations
 *     @property {string} im_url - hit.imageUrl
 * }
 */

export function cardViewEvent(context, labelData = {}, actionLocation) {
    triggerEdapEventLegacy(context, {
        fields: {
            ...EVENT_CATEGORY,
            ...EVENT_ACTIONS.CARD_VIEW,
            ...getLabel(labelData),
            actionlocation: actionLocation,
        },
    });
}

/**
 * Triggers EDAP event when a user right-clicks on a card
 * @param context {@link CarouselContainer.contextType}
 * @param {object} labelData - Object used by {@link getLabel} to generate 'eventlabel' {
 *     @property {string} rrm - clientRequestId AKA X-HomeAway-RequestMarker header
 *     @property {number} position - card position in carousel (basically its index)
 *     @property {string} lid - hit.listingId, for example, 121.302.120
 *     @property {string} link - hit.propertyHref
 * }
 */

export function cardContextMenuClickEvent(
    context,
    labelData = {},
    actionLocation
) {
    triggerEdapEventLegacy(context, {
        fields: {
            ...EVENT_CATEGORY,
            ...EVENT_ACTIONS.CONTEXT_MENU,
            ...getLabel(labelData),
            actionlocation: actionLocation,
        },
    });
}

/**
 *
 * @param context {@link CarouselContainer.contextType}
 * @param actionLocation { object } - Object with actionlocation field specifying the client of the carousel
 */

export function previousClick(context, actionLocation = {}) {
    triggerEdapEventLegacy(context, {
        event: 'nav.previous.click',
        fields: {
            actionlocation: actionLocation,
        },
    });
}

/**
 *
 * @param context {@link CarouselContainer.contextType}
 * @param actionLocation { object } - Object with actionlocation field specifying the client of the carousel
 */

export function nextClick(context, actionLocation) {
    triggerEdapEventLegacy(context, {
        event: 'nav.next.click',
        fields: {
            actionlocation: actionLocation,
        },
    });
}

/**
 *
 * @param context {@link CarouselContainer.contextType}
 */

export function seeMoreButtonClick(context) {
    triggerEdapEventLegacy(context, {
        fields: {
            eventcategory: 'pdp page',
            ...EVENT_ACTIONS.SEE_MORE_BUTTON_CLICK,
        },
    });
}

/**
 *
 * @param context {@link CarouselContainer.contextType}
 * @param shouldFireEvent {boolean} - defines whether event should be triggered or not
 * @param eventcategory {string}
 */

export function seeMoreCardClick(context, shouldFireEvent) {
    if (shouldFireEvent) {
        triggerEdapEventLegacy(context, {
            fields: {
                eventcategory: 'pdp page',
                ...EVENT_ACTIONS.SEE_MORE_CARD_CLICK,
            },
        });
    }
}
